import palette from 'components/palette'
import React from 'react'
import styled from 'styled-components'
import { color } from 'utils'

type StyledInputProps = { hasError?: boolean }
const StyledInput = styled.input<StyledInputProps>`
  padding: 0.75rem 1rem;
  color: ${color('white')};
  background: ${color('dark900')};
  border: 1px solid ${(p) => (p.hasError ? color('errorMuted') : color('dark500'))};
  border-radius: 0.5rem;
  outline: none;

  :focus {
    border-color: ${color('primaryMuted')};
  }

  /* Horrible hack to avoid round corners on input siblings */
  :not(:only-of-type) {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  & + & {
    /* Input next to Input */
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }
  /* End of horrible hack */
`

// FIXME: type any
const Input = React.forwardRef((props: any, ref: any) => (
  <StyledInput {...props} ref={ref} onChange={(e) => props.onChange(e.target.value)} />
))

export const InputWrapper = styled.div`
  padding: 0;
  margin: 0;
  border: 0;
  display: flex;
  flex-direction: column;

  & + & {
    /* InputWrapper next to InputWrapper */
    margin-top: 1rem;
  }
`

type HelperProps = {
  themeName?: 'light' | 'dark'
  type?: 'default' | 'success' | 'error'
}
const helperColors = {
  dark: {
    default: palette.grey300,
    error: palette.red400,
    success: palette.successMuted
  },
  light: {
    default: palette.grey600,
    error: palette.red600,
    success: palette.green600
  }
}
export const Helper = styled.span<HelperProps>`
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 1rem;
  color: ${(p) => helperColors[p.themeName ?? 'dark'][p.type ?? 'default']};
`

const StyledLabel = styled.label<LabelProps>`
  color: ${(p) => (p.theme === 'light' ? color('text') : color('medium'))};
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.25rem;
  padding: 8px 0;
  margin: 0;
`
type LabelProps = {
  theme?: 'dark' | 'light'
} & Omit<React.HTMLProps<HTMLLabelElement>, 'ref' | 'as'>
export const Label = (props: LabelProps) => <StyledLabel {...props} />

export default Input
